import React, { useState, useEffect } from 'react';
import { Modal, Table, Button, Space, message } from 'antd';
import { TestData, Folder } from '../../types/testItem';
import { testItemService } from '../../services/testItemService';

interface Props {
    visible: boolean;
    onCancel: () => void;
    onSelect: (data: TestData[]) => void;
    projectId: number;
    selectedFolder: Folder | null;
}

export const SelectTestDataModal: React.FC<Props> = ({
    visible,
    onCancel,
    onSelect,
    projectId,
    selectedFolder,
}) => {
    const [testData, setTestData] = useState<TestData[]>([]);
    const [selectedRows, setSelectedRows] = useState<TestData[]>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (visible) {
            fetchTestData();
        }
    }, [visible]);

    const fetchTestData = async () => {
        try {
            setLoading(true);
            const data = await testItemService.getTestData(projectId);
            // Фильтруем данные, которые уже привязаны к другим папкам
            const availableData = data.filter((item: TestData) => !item.folder_id);
            setTestData(availableData);
        } catch (error) {
            message.error('Не удалось загрузить тестовые данные');
        } finally {
            setLoading(false);
        }
    };

    const columns = [
        {
            title: 'Название',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Описание',
            dataIndex: 'description',
            key: 'description',
        },
    ];

    const rowSelection = {
        onChange: (_: React.Key[], selectedRows: TestData[]) => {
            setSelectedRows(selectedRows);
        },
    };

    const handleOk = () => {
        onSelect(selectedRows);
    };

    return (
        <Modal
            title={`Добавить тестовые данные в папку "${selectedFolder?.name}"`}
            open={visible}
            onCancel={onCancel}
            onOk={handleOk}
            okButtonProps={{ disabled: selectedRows.length === 0 }}
            width={800}
        >
            <Table
                columns={columns}
                dataSource={testData}
                loading={loading}
                rowSelection={{
                    type: 'checkbox',
                    ...rowSelection,
                }}
                rowKey="id"
            />
        </Modal>
    );
}; 